import { CSSProperties } from "react";

import { styles } from "@repo/helpers";

import { InputComponent } from "../input";
import style from "./style.module.scss";
import { LabelPositionEnum, MarkupProps } from "./types";

export default function ToggleSliderMarkup(props: MarkupProps) {
	const {
		activeColor,
		inactiveColor,
		sliderBorderColor,
		labelPosition,
		rounded,
		small,
		trueLabel,
		falseLabel,
		focused,
		updateFocused,
		onChange,
		...inputProps
	} = props;
	const { id, name, value, disabled } = inputProps;
	const inlineStyle = {} as CSSProperties;
	if (activeColor && value) {
		inlineStyle.backgroundColor = activeColor;
	} else if (inactiveColor && !props.value) {
		inlineStyle.backgroundColor = inactiveColor;
	}
	if (sliderBorderColor) {
		inlineStyle.borderColor = sliderBorderColor;
	}
	const sliderStyle = styles(
		props.className,
		style.slider,
		small && style.smallLine,
		rounded && style.sliderRound,
		disabled && style.disabled,
	);

	const switchStyle = styles(
		style.switchLabel,
		small && style.smallLabel,
		labelPosition === LabelPositionEnum.left ? style.labelLeft : style.labelRight,
	);

	const switchGroup = (
		<label className={style.switchGroup}>
			<input
				type="checkbox"
				className={style.sliderInput}
				checked={!!value || false}
				disabled={disabled}
				onChange={onChange}
				id={id || name}
				name={name || id}
				onFocus={updateFocused}
				onBlur={props.updateFocused}
			/>
			<span className={sliderStyle} style={inlineStyle} />
		</label>
	);
	const switchLabel = <label className={switchStyle}>{value ? trueLabel : falseLabel}</label>;

	return (
		<InputComponent {...inputProps}>
			<div className={styles(style.toggleGroup, focused && style.focused)}>
				{labelPosition === LabelPositionEnum.left && switchLabel}
				{switchGroup}
				{labelPosition === LabelPositionEnum.right && switchLabel}
			</div>
		</InputComponent>
	);
}
